import { useEffect, useState } from "react";
import api from "@/lib/api";

export const DEFAULT_SETTINGS = {
  address: "Palligewatta, Arapotha, Kottagoda, Dikwella",
  phone1: "+94 70 311 9153",
  phone2: "+94 72 552 6992",
  email: "citizentravels995@gmail.com",
  whatsapp: "94761609626",
};

export function useSiteSettings() {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    api
      .get("/settings")
      .then((r) => setSettings({ ...DEFAULT_SETTINGS, ...r.data }))
      .catch(() => {});
  }, []);

  return settings;
}
